module.exports = __webpack_public_path__ + "img/frame_IELTS_grade.8e8471b2.svg";